"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiImagePicker = void 0;
var react_1 = require("react");
var index_1 = require("./index");
function useMultiImagePicker() {
    return react_1.useContext(index_1.MultiImagePickerContext);
}
exports.useMultiImagePicker = useMultiImagePicker;
//# sourceMappingURL=hooks.js.map